/* dv-kesim-varyantlari.js — otomatik uretildi 2026-07-31
   Ozel olcu sepet satiri: varyant = rulo eni, adet = uzunluk (cm).
   Kaynak: data/ozel_olcu_plus_config.json + canli Shopify varyant fiyatlari.
   ELLE DEGISTIRME — dv-kesim-harita-uret.js ile yeniden uret. */
window.__DV_KESIM_VARIANTS__ = {
 "paradiso-plus|biye": {
  "handle": "dv-kesim-paradiso-plus",
  "urunId": 9384867954904,
  "enler": {
   "80": {
    "id": 52102169952472,
    "birim": 22.72
   },
   "100": {
    "id": 52102169985240,
    "birim": 28.4
   },
   "120": {
    "id": 52102170018008,
    "birim": 34.08
   },
   "160": {
    "id": 52102170050776,
    "birim": 45.44
   },
   "200": {
    "id": 52102170083544,
    "birim": 56.8
   }
  }
 },
 "paradiso-plus|bordur": {
  "handle": "dv-kesim-paradiso-plus-bordur",
  "urunId": 9385449291992,
  "enler": {
   "80": {
    "id": 52104479211736,
    "birim": 27.94
   },
   "100": {
    "id": 52104479244504,
    "birim": 34.93
   },
   "120": {
    "id": 52104479277272,
    "birim": 41.91
   },
   "160": {
    "id": 52104479310040,
    "birim": 55.89
   },
   "200": {
    "id": 52104479342808,
    "birim": 69.86
   }
  }
 },
 "paradiso-plus|overlok": {
  "handle": "dv-kesim-paradiso-plus-overlok",
  "urunId": 9385449193688,
  "enler": {
   "80": {
    "id": 52104478916824,
    "birim": 15.84
   },
   "100": {
    "id": 52104478949592,
    "birim": 19.8
   },
   "120": {
    "id": 52104478982360,
    "birim": 23.76
   },
   "160": {
    "id": 52104479015128,
    "birim": 31.68
   },
   "200": {
    "id": 52104479047896,
    "birim": 39.6
   }
  }
 },
 "tokyo|overlok": {
  "handle": "dv-kesim-tokyo",
  "urunId": 9384867496152,
  "enler": {
   "80": {
    "id": 52102166544600,
    "birim": 20
   },
   "100": {
    "id": 52102166577368,
    "birim": 25
   },
   "120": {
    "id": 52102166610136,
    "birim": 30
   },
   "160": {
    "id": 52102166642904,
    "birim": 40
   },
   "200": {
    "id": 52102166675672,
    "birim": 50
   }
  }
 },
 "monza|overlok": {
  "handle": "dv-kesim-monza",
  "urunId": 9384867594456,
  "enler": {
   "80": {
    "id": 52102167429336,
    "birim": 24.82
   },
   "100": {
    "id": 52102167462104,
    "birim": 31.03
   },
   "120": {
    "id": 52102167494872,
    "birim": 37.23
   },
   "160": {
    "id": 52102167527640,
    "birim": 49.64
   },
   "200": {
    "id": 52102167560408,
    "birim": 62.06
   }
  }
 },
 "puffy|overlok": {
  "handle": "dv-kesim-puffy",
  "urunId": 9384867659992,
  "enler": {
   "80": {
    "id": 52102167625944,
    "birim": 17.33
   },
   "100": {
    "id": 52102167658712,
    "birim": 21.67
   },
   "120": {
    "id": 52102167691480,
    "birim": 26
   },
   "160": {
    "id": 52102167724248,
    "birim": 34.67
   },
   "200": {
    "id": 52102167757016,
    "birim": 43.34
   }
  }
 },
 "garda|overlok": {
  "handle": "dv-kesim-garda",
  "urunId": 9384867823832,
  "enler": {
   "80": {
    "id": 52102169166040,
    "birim": 12.96
   },
   "100": {
    "id": 52102169198808,
    "birim": 16.2
   },
   "120": {
    "id": 52102169231576,
    "birim": 19.44
   },
   "160": {
    "id": 52102169264344,
    "birim": 25.92
   },
   "200": {
    "id": 52102169297112,
    "birim": 32.4
   }
  }
 },
 "record|overlok": {
  "handle": "dv-kesim-record",
  "urunId": 9384867856600,
  "enler": {
   "80": {
    "id": 52102169362648,
    "birim": 17.2
   },
   "100": {
    "id": 52102169395416,
    "birim": 21.5
   },
   "120": {
    "id": 52102169428184,
    "birim": 25.8
   },
   "160": {
    "id": 52102169460952,
    "birim": 34.4
   },
   "200": {
    "id": 52102169493720,
    "birim": 43
   }
  }
 },
 "bohem|overlok": {
  "handle": "dv-kesim-bohem",
  "urunId": 9384867889368,
  "enler": {
   "80": {
    "id": 52102169559256,
    "birim": 15.12
   },
   "100": {
    "id": 52102169592024,
    "birim": 18.9
   },
   "120": {
    "id": 52102169624792,
    "birim": 22.68
   },
   "160": {
    "id": 52102169657560,
    "birim": 30.24
   },
   "200": {
    "id": 52102169690328,
    "birim": 37.8
   }
  }
 },
 "opera|overlok": {
  "handle": "dv-kesim-opera",
  "urunId": 9384867692760,
  "enler": {
   "80": {
    "id": 52102168248536,
    "birim": 29.2
   },
   "100": {
    "id": 52102168281304,
    "birim": 36.5
   },
   "120": {
    "id": 52102168314072,
    "birim": 43.8
   },
   "160": {
    "id": 52102168346840,
    "birim": 58.4
   },
   "200": {
    "id": 52102168379608,
    "birim": 73
   }
  }
 },
 "jakarta|overlok": {
  "handle": "dv-kesim-jakarta",
  "urunId": 9384867922136,
  "enler": {
   "80": {
    "id": 52102169755864,
    "birim": 14.08
   },
   "100": {
    "id": 52102169788632,
    "birim": 17.6
   },
   "120": {
    "id": 52102169821400,
    "birim": 21.12
   },
   "160": {
    "id": 52102169854168,
    "birim": 28.16
   },
   "200": {
    "id": 52102169886936,
    "birim": 35.2
   }
  }
 },
 "sumatra|overlok": {
  "handle": "dv-kesim-sumatra",
  "urunId": 9384867758296,
  "enler": {
   "80": {
    "id": 52102168707288,
    "birim": 15.84
   },
   "100": {
    "id": 52102168740056,
    "birim": 19.8
   },
   "120": {
    "id": 52102168772824,
    "birim": 23.76
   },
   "160": {
    "id": 52102168805592,
    "birim": 31.68
   },
   "200": {
    "id": 52102168838360,
    "birim": 39.6
   }
  }
 },
 "macaron|overlok": {
  "handle": "dv-kesim-macaron",
  "urunId": 9384867561688,
  "enler": {
   "80": {
    "id": 52102167199960,
    "birim": 15.84
   },
   "100": {
    "id": 52102167232728,
    "birim": 19.8
   },
   "120": {
    "id": 52102167265496,
    "birim": 23.76
   },
   "160": {
    "id": 52102167298264,
    "birim": 31.68
   },
   "200": {
    "id": 52102167331032,
    "birim": 39.6
   }
  }
 },
 "nordic|overlok": {
  "handle": "dv-kesim-nordic",
  "urunId": 9384867528920,
  "enler": {
   "80": {
    "id": 52102167003352,
    "birim": 15.56
   },
   "100": {
    "id": 52102167036120,
    "birim": 19.45
   },
   "120": {
    "id": 52102167068888,
    "birim": 23.34
   },
   "160": {
    "id": 52102167101656,
    "birim": 31.12
   },
   "200": {
    "id": 52102167134424,
    "birim": 38.9
   }
  }
 }
};
